<template>
    <el-date-picker
        v-model="bindValue"
        type="month"
        placeholder="请输入批次号"
        format="yyyyMM"
        :size="size"
        :style="{width: width}"
        @change="updateValue">
    </el-date-picker>
</template>
<script>
    /**
     * 批次组件，基于element-ui的DatePicker封装
     * @author zjs
     * @time 2017-09-12
     */
    export default {
        name: 'LyBatch',
        props: {
            value: {
                type: [String,Date],
                default: ''
            },
            width: {
                type: String,
                default: '220px'
            },
            size: {
                type: String,
                default: 'small'
            }
        },
        data () {
            return {
                bindValue: '', // 批次绑定的值
                isEmitInput: true // 标识是否触发emit
            }
        },
        created () {
            this.bindValue = this.value
        },
        watch: {
            value (val) {
                if (this.bindValue !== val) {
                    if (this.value && this.value.length >= 6) {
                        this.isEmitInput = false
                        // 获得年
                        let year = this.value.substring(0, this.value.length - 2)
                        // 获得月
                        let month = this.value.substring(this.value.length - 2) - 1
                        // 设置时间
                        let time = new Date()
                        time.setFullYear(year, month)
                        this.bindValue = time
                    } else {
                        this.bindValue = ''
                    }
                }
            }
        },
        methods: {
            updateValue: function (value) {
                if (this.value !== value) {
                    this.$emit('input', value)
                }
            }
        }
    }
</script>